<tam-dialog class="exchange-duplicate-dialog" [opened]="isOpened" [dialogWidth]="dialogWidth">
    <ng-template #title>
        <span class="dialog-title">{{titleName}}</span>
        <smart-icon class="dialog-close dark" name="close" (click)="onCloseBtnClick($event)">
        </smart-icon>
    </ng-template>
    <ng-template #body>
        <div class="bodyContainer">
            <div class="use-record">{{'exchange.differenct_on_contact_data_between_exchange_and_tamale' |
                stringLiterals}} </div>
            <div class="body-container body-1">
                <div *ngFor="let item of duplicateData; trackBy:trackByFn" class="item-container">
                    <div class="information-container" *ngIf="item.duplicates.length>0">
                        <div class="exchange-contact-header">
                            <div class="contact-name">
                                <span class="exchange-title">{{item.exchange.name}}</span>
                                <span *ngIf="item.exchange.emailAddress">
                                    {{item.exchange.emailAddress}}
                                </span>
                            </div>
                            <div class="exchange-operator">
                                <label *ngIf="!item.isMergedAll" (click)="onClickMergeAll(item)">{{'general.merge_all' |
                                    stringLiterals}}</label>
                                <label *ngIf="item.isMergedAll" class="merge-contact-undo"
                                    (click)="onClickUndoMerge(item)">{{'general.undo_merge' |
                                    stringLiterals}}</label>
                            </div>
                        </div>
                        <div class="item-duplicate-detail">
                            <div *ngFor="let duplicateItem of item.duplicates; trackBy:trackByFn">
                                <div *ngIf="!duplicateItem.isMergedItem" class="item-duplicate-info">
                                    <div style="width: 100%; display: flex;"
                                        [ngClass]="{'invalid-item':getDuplicateItemStatus(duplicateItem)}">
                                        <div class="item-duplicate-name">
                                            {{handleShowName(duplicateItem.duplicateNameShowOnUI)}}</div>
                                        <div class="item-duplicate-value hover-item"
                                            [ngClass]="{'selected-item':duplicateItem.isTamaleValueSelected}"
                                            (click)="onClickTamaleItem(duplicateItem)">
                                            <div class="item-value">{{getDisplayItem(duplicateItem.tamaleValue,
                                                duplicateItem)}}
                                            </div>
                                        </div>
                                        <div class="item-duplicate-value hover-item"
                                            [ngClass]="{'selected-item':duplicateItem.isExchangeValueSelected}"
                                            (click)="onClickExchangeItem(duplicateItem)">
                                            <div class="item-value">
                                                {{getDisplayItem(duplicateItem.exchangeValue, duplicateItem)}}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="item-duplicate-action">
                                        <div *ngIf="!duplicateItem.isMergedItem"
                                            (click)="onClickMergeItem(duplicateItem)">{{'general.merge' |
                                            stringLiterals}}</div>
                                    </div>
                                </div>
                                <div *ngIf="duplicateItem.isMergedItem" class="item-duplicate-info">
                                    <div class="item-duplicate-content" *ngIf="!duplicateItem.isUseMostRecentData">
                                        <div *ngIf="isCombineDuplicateValue(duplicateItem)">
                                            <div class="item-duplicate-merged">
                                                <div class="item-duplicate-name-merged">
                                                    {{handleShowName(duplicateItem.duplicateNameShowOnUI)}}
                                                </div>
                                                <div class="item-duplicate-value-merged">
                                                    {{showCombineValue(duplicateItem)}}
                                                </div>
                                            </div>
                                        </div>
                                        <div *ngIf="!isCombineDuplicateValue(duplicateItem)">
                                            <div class="item-duplicate-merged">
                                                <div class="item-duplicate-name-merged">
                                                    {{handleShowName(duplicateItem.duplicateNameShowOnUI)}}
                                                </div>
                                                <div class="item-duplicate-value-merged">
                                                    {{getDisplayItem(duplicateItem.tamaleValue,duplicateItem)}}
                                                </div>
                                            </div>
                                            <div class="item-duplicate-merged">
                                                <div class="item-duplicate-name-merged">
                                                    {{handleShowName(duplicateItem.duplicateNameShowOnUI)}}
                                                </div>
                                                <div class="item-duplicate-value-merged">
                                                    {{getDisplayItem(duplicateItem.exchangeValue,duplicateItem)}}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="item-duplicate-content" *ngIf="duplicateItem.isUseMostRecentData">
                                        <div *ngIf="isCombineDuplicateValue(duplicateItem)">
                                            <div class="item-duplicate-merged">
                                                <div class="item-duplicate-name-merged">
                                                    {{handleShowName(duplicateItem.duplicateNameShowOnUI)}}
                                                </div>
                                                <div class="item-duplicate-value-merged">
                                                    {{getDisplayItem(duplicateItem.tamaleValue,duplicateItem)}} <br>
                                                    {{getDisplayItem(duplicateItem.exchangeValue,duplicateItem)}}
                                                </div>
                                            </div>
                                        </div>
                                        <div *ngIf="!isCombineDuplicateValue(duplicateItem)">
                                            <div class="item-duplicate-merged">
                                                <div class="item-duplicate-name-merged">
                                                    {{handleShowName(duplicateItem.duplicateNameShowOnUI)}}
                                                </div>
                                                <div class="item-duplicate-value-merged"
                                                    *ngIf="item.tamaleModifyDate >= item.exchangeModifyDate">
                                                    {{getDisplayItem(duplicateItem.tamaleValue,duplicateItem)}}
                                                </div>
                                                <div class="item-duplicate-value-merged"
                                                    *ngIf="item.exchangeModifyDate > item.tamaleModifyDate">
                                                    {{getDisplayItem(duplicateItem.exchangeValue,duplicateItem)}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="item-duplicate-action">
                                        <div *ngIf="duplicateItem.isMergedItem"
                                            (click)="onClickUndoMergeItem(duplicateItem)">{{'general.undo'
                                            |stringLiterals}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ng-template>
    <ng-template #footer>
        <button tam-button tamType="tertiary" tamSize="normal" class="dialog-button"
            (click)="onCancelBtnClick($event)">{{'general.back' | stringLiterals}}</button>
        <button tam-button tamType="primary" tamSize="normal" class="import-button" (click)="onClickImport($event)"
            [tamLoading]="isProgressing" [disabled]="isProgressing">{{'general.import' | stringLiterals}}</button>
    </ng-template>
</tam-dialog>